import React, { useCallback } from 'react';
import { useParams } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { AppModal } from '@/layout/AppComponents';
import axios from 'axios';
import { Formik } from 'formik';
import * as Yup from 'yup';
import * as currentPageAction from '../../../../../../store/actions/currentPageAction';
import { axiosPath } from '../../../../../../routing/helpers/router';
import useIsMounted from '../../../../../components/hooks/useIsMounted';
import errorHandler from '@/layout/components/error/ErrorHandler';
import TotalEnergiesRiskProcessSelect from "../../../../../components/form/Selects/TotalEnergiesRiskProcessSelect";

export default function ProcessDelete({
  id,
  process,
  showModal,
  setShowModal,
}) {
  const { moduleBridgeHex } = useParams();
  const isMounted = useIsMounted();
  const dispatch = useDispatch();
  const validationSchema = Yup.object().shape({
    processToTransfer: Yup.number()
      .nullable()
      .required('Requerido'),
  });

  const handleDelete = useCallback(
    async (values) =>
      axios
        .delete(
          axiosPath("api_r_user_module_totalEnergiesRisk_process_delete"),
          {
            data: {
              moduleBridgeHex,
              id,
              ...values,
            },
          }
        )
        .then(() => {
          if (isMounted.current) {
            dispatch(currentPageAction.change("loading", true));
            setShowModal(undefined);
          }
        })
        .catch((e) => dispatch(errorHandler(e))),
    [moduleBridgeHex, id]
  );

  return (
    <AppModal
      show={showModal !== undefined}
      size="lg"
      title={`Eliminar ${showModal === 'process' ? 'proceso' : 'subproceso'}`}
      onClose={() => setShowModal(undefined)}
    >
      <Formik
        validateOnChange={false}
        validateOnBlur={false}
        validationSchema={validationSchema}
        initialValues={{
          processToTransfer: null,
        }}
        onSubmit={handleDelete}
      >
        {({ setFieldValue, handleSubmit, values, errors, isSubmitting }) => (
          <form onSubmit={handleSubmit}>
            <div className="container-fluid">
              <div className="row">
                <div className="col-lg-12">
                  <p>
                    ¿Desea eliminar{' '}
                    <b>
                      {process.shortName} - {process.name}
                    </b>
                    ?
                  </p>
                  <p>
                    {showModal === 'process'
                      ? 'Seleccione un proceso al que migrar sus subprocesos'
                      : 'Seleccione otro subproceso para migrar los riesgos'}
                    :
                  </p>
                </div>
                <div className="col-lg-12">
                  <TotalEnergiesRiskProcessSelect
                    value={values?.processToTransfer}
                    error={errors?.processToTransfer}
                    onHandleChange={(opt) => {
                      setFieldValue('processToTransfer', opt);
                    }}
                    onlyParents={showModal === 'process'}
                    hasSearchBox
                    filterID={id}
                    required
                  />
                </div>
              </div>
            </div>
            <div className="row mt-3">
              <div className="col-12">
                <button
                  type="submit"
                  className="btn btn-sm btn-danger float-right"
                  disabled={isSubmitting}
                >
                  Eliminar
                </button>
                <button
                  type="button"
                  onClick={() => setShowModal(undefined)}
                  className="btn btn-sm btn-outline-danger float-right mr-2"
                >
                  Cancelar
                </button>
              </div>
            </div>
          </form>
        )}
      </Formik>
    </AppModal>
  );
}
